// IMPORT PACKAGE REFERENCES
import React from 'react';

// IMPORT PROJECT REFERENCES

import { DeviceBrowser } from '../../DeviceBrowser/DeviceBrowser';


// COMPONENT

export const DeviceListPage = () => (
    <div className="animated fadeIn">
        <DeviceBrowser />
    </div>
);